<template>
  <div class="Background">

    <div style="display: flex; justify-content: space-between;">
      <h2 class="Title">
        인코딩 서버 등록
      </h2>

      <div class="link_location">
        설정관리 <v-icon small class="mdi mdi-chevron-right" />
        시스템관리 <v-icon small class="mdi mdi-chevron-right" />
        <a href="/admin/Encoding-Server">인코딩 서버 등록</a>
      </div>
    </div>

    <v-card class="pa-5" elevation="0">
      <v-card-text>
        <v-row>
          <v-col>
            <h4 class="mb-2" style="color:black;">이름</h4>
            <v-form ref="form" v-model="valid" lazy-validation>
              <input v-model="name" :rules="nameRule" label="호스트 이름" :counter="10" required placeholder="호스트 이름"
                class="search-input" ref="nameInput">
            </v-form>
          </v-col>

          <v-col class="ml-3 mr-3">
            <h4 class="mb-2" style="color:black;">IP</h4>
            <v-form ref="form" v-model="valid" lazy-validation>
              <input v-model="ip" :rules="ipRule" label="아이피" required placeholder="아이피" class="search-input"
                ref="ipInput">
            </v-form>
          </v-col>

          <v-col>
            <h4 class="mb-2" style="color:black;">포트</h4>
            <v-form ref="form" v-model="valid" lazy-validation>
              <input v-model="port" :rules="portRule" label="포트" required placeholder="포트" class="search-input"
                ref="portInput">
            </v-form>
          </v-col>
        </v-row>

      </v-card-text>

    </v-card>

    <v-row justify="end" class="bg-purple mt-3 mr-0">
      <v-col v-for="count in 1" :key="count" cols="auto">
        <TextButton buttonText="취소" @click="cancel" class="mr-2" />
        <TextButton buttonText="등록" @click="addServer" isPrimary />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TextButton from '@/components/ui/button/TextButton2.vue';
import EncodingServerApi from "@/api/encodingserver/EncodingServerApi";

export default {
  components: {
    TextButton
  },
  data() {
    return {
      nameRule: [
        v => !!v || 'Name is required',
        v => /^[a-zA-Z][a-zA-Z0-9]*$/.test(v) || 'Must start with a letter and can use letters and numbers',
        v => v && v.length >= 2 && v.length <= 50 || 'Name must be between 2 and 50 characters',
      ],
      ipRule: [
        v => !!v || "IP Address is required",
        v =>
          /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
            v
          ) || "IP Address is invalid",
      ],
      portRule: [
        (v) => !!v || "Port is required",
        (v) => /^\d+$/.test(v) || "Port must be a number",
        (v) => v >= 0 && v <= 65535 || "Port must be between 0 and 65535",
      ],
      name: '',
      ip: '',
      port: '',
      valid: true,
    }
  },
  methods: {
    cancel() {
      this.$router.push('/admin/encodingservers_list');
    },
    async addServer() {
      const data = {
        name: this.name,
        ip: this.ip,
        port: this.port
      }
      const response = await EncodingServerApi.addApi(data);
      if (response.status === 201) {
        this.$router.push('/admin/encodingservers_list');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-input {
  width: 100%;
  height: 36px;
  padding: 8px;
  margin-bottom: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 14px;
  background: #fff;
}

input:focus {
  outline: none;
  border: 1px solid #999;
}
</style>